import React from "react";
import { Link } from "react-router-dom";
import { img, studies, timeline } from "../config";
import { Reveal, Badge, Img } from "../components/Primitives";

export default function Science() {
  return (
    <main data-testid="science-page">
      <section className="section" style={{ paddingBottom: 40 }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <Reveal>
            <h1 className="title-xl" style={{ fontSize: "clamp(36px,8vw,64px)" }}>LA SCIENCE, SANS FILTRE.</h1>
            <p style={{ color: "var(--text-muted)", marginTop: 16, fontSize: 18 }}>Nous ne vous demandons pas de nous croire. Voici les études, leurs protocoles et leurs résultats — avec les liens pour tout vérifier.</p>
          </Reveal>
        </div>
      </section>

      <section className="section" style={{ background: "var(--surface)", paddingTop: 56, paddingBottom: 56 }}>
        <div className="wrap crush-g2" style={{ gap: 48, alignItems: "center" }}>
          <Reveal>
            <h2 className="title-xl" style={{ fontSize: 30 }}>C'EST QUOI LA NANO-HYDROXYAPATITE ?</h2>
            <p style={{ color: "var(--text-muted)", marginTop: 16 }}>L'hydroxyapatite est le minéral qui constitue environ 97 % de l'émail dentaire. Sous forme nano, appliquée au brossage, elle se dépose dans les microfissures de surface et contribue à reminéraliser l'émail fragilisé. Étudiée depuis les années 1970, standard anticarie au Japon depuis les années 1980, c'est aujourd'hui l'alternative au fluor la plus documentée au monde.</p>
          </Reveal>
          <Reveal delay={0.15}><Img src={img.nha_science} alt="Nano-hydroxyapatite" sizes="(min-width:900px) 50vw, 100vw" style={{ width: "100%", borderRadius: 4, border: "1px solid var(--border)" }} /></Reveal>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 56, paddingBottom: 56 }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <h2 className="title-xl" style={{ fontSize: 30 }}>LA FRISE HISTORIQUE.</h2>
          <div style={{ marginTop: 32 }}>
            {timeline.map((t, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div style={{ display: "grid", gridTemplateColumns: "90px 1fr", gap: 20, padding: "20px 0", borderTop: "1px solid var(--border)" }}>
                  <span className="display" style={{ color: "var(--accent)", fontWeight: 700, fontSize: 20 }}>{t.year}</span>
                  <p style={{ margin: 0, color: "var(--text-muted)" }}>{t.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: "var(--surface)", paddingTop: 56, paddingBottom: 56 }}>
        <div className="wrap">
          <h2 className="title-xl" style={{ fontSize: 30 }}>LES 3 ÉTUDES CLINIQUES.</h2>
          <div style={{ display: "grid", gap: 20, gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", marginTop: 32 }}>
            {studies.map((s, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="card" style={{ padding: 24, height: "100%", display: "flex", flexDirection: "column" }}>
                  <span className="eyebrow" style={{ color: "var(--accent-light)" }}>{s.meta}</span>
                  <p style={{ color: "var(--text-muted)", fontSize: 14, marginTop: 14, flex: 1 }}>{s.text}</p>
                  <a href={s.url} target="_blank" rel="noopener noreferrer" className="link-accent" data-testid={`study-link-${i}`} style={{ marginTop: 14 }}>Lire l'étude →</a>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 56, paddingBottom: 56 }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <Badge>Notre choix</Badge>
          <h2 className="title-xl" style={{ fontSize: 30, marginTop: 16 }}>NOTRE CHOIX DU SANS-FLUOR.</h2>
          <p style={{ color: "var(--text-muted)", marginTop: 16 }}>Le fluor fonctionne, la science est claire là-dessus. Nous avons choisi une autre voie, tout aussi documentée : apporter à l'émail le minéral qui le compose, plutôt qu'un agent externe. Un choix, pas une croisade — désormais soutenu par des essais cliniques.</p>
          <p style={{ color: "var(--text-muted)", fontSize: 13, marginTop: 32 }}>CRUSH est un produit cosmétique d'hygiène bucco-dentaire. Il ne remplace pas un suivi dentaire régulier.</p>
          <div style={{ marginTop: 24 }}><Link to="/kit" className="btn btn-primary" data-testid="science-cta">Découvrir le kit — 45 €</Link></div>
        </div>
      </section>
    </main>
  );
}
